import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HomePageReviews = () => {
    const [reviews, setReviews] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedVideoId, setSelectedVideoId] = useState(null);
    const [allReviews, setAllReviews] = useState([]);
    const [filterVisible, setFilterVisible] = useState(false);
    const [filterApproved, setFilterApproved] = useState(false);
    const [showReviewConfirm, setShowReviewConfirm] = useState(false);
    const [selectedReviewId, setSelectedReviewId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const reviewsPerPage = 5;

    // Fetch all 
    useEffect(() => {
        fetchReviews();
    }, []);

    useEffect(() => {
        let filtered = allReviews;

        if (filterVisible) {
            filtered = filtered.filter(r => r.showReview);
        }

        if (filterApproved) {
            filtered = filtered.filter(r => r.showHide);
        }

        setReviews(filtered);
    }, [filterVisible, filterApproved, allReviews])

    const fetchReviews = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/customerreview`);
            setAllReviews(response.data);
            setReviews(response.data);
        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    // Handle delete confirmation
    const handleDelete = (_id) => {
        setSelectedVideoId(_id);
        setShowConfirm(true);
    };

    const confirmDelete = async (id) => {
        try {
            await axios.delete(`${backend_url}/api/customerreview/${id}`);
            setShowConfirm(false);
            toast.success("Review Deleted Successfully")
            fetchReviews();
        } catch (error) {
            console.error("Error deleting video:", error);
        }
    };

    const confirmShowReview = async () => {
        try {
            await axios.patch(`${backend_url}/api/customerreviews/${selectedReviewId}/showReview`, {
                showReview: true
            });
            toast.success("Review marked as visible!");
            setShowReviewConfirm(false);
            fetchReviews(); // Refresh the list
        } catch (error) {
            toast.error("Failed to update review");
            console.error("Error updating showReview:", error);
        }
    };

    const renderStars = (rating) => {
        const filledStars = parseInt(rating, 10);
        return "★".repeat(filledStars) + "☆".repeat(5 - filledStars);
    };

    const paginatedReviews = reviews.slice(
        currentPage * reviewsPerPage,
        (currentPage + 1) * reviewsPerPage
    );

    const totalPages = Math.ceil(reviews.length / reviewsPerPage);

    return (
        <>
            <div className="variety-admin">
                <div className="headerSections">
                    <div className="head-title">Reviews</div>
                </div>

                <div className="filter-controls">
                    <div className="filter-item">
                        <label>
                            <input
                                type="checkbox"
                                checked={filterVisible}
                                onChange={(e) => setFilterVisible(e.target.checked)}
                            />
                            Show Only Visible Reviews
                        </label>
                    </div>
                    <div className="filter-item">
                        <label>
                            <input
                                type="checkbox"
                                checked={filterApproved}
                                onChange={(e) => setFilterApproved(e.target.checked)}
                            />
                            Show Only Approved Reviews
                        </label>
                    </div>

                </div>


                {/* List Table */}
                <table className="variety-table">
                    <thead>
                        <tr>
                            <th>Customer Name</th>
                            <th>Email</th>
                            <th>Rating</th>
                            <th>Review</th>
                            <th>Review Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedReviews.map((review) => (
                            <tr key={review._id}>
                                <td>{review.name}</td>
                                <td>{review.email}</td>
                                <td>{renderStars(review.rating)}</td>
                                <td>
                                    <b>{review.reviewTitle}</b> -
                                    {review.review}
                                </td>
                                <td>
                                    <img src={`${review.reviewImage}`} alt={review.reviewTitle} />
                                </td>
                                <td>
                                    {review.showReview ? (
                                        <button
                                        style={{ backgroundColor: "red", opacity: 0.8, color: "white" }}
                                            onClick={async () => {
                                                try {
                                                    await axios.patch(`${backend_url}/api/customerreviews/${review._id}/showReview`, {
                                                        showReview: false,
                                                    });
                                                    toast.success("Review hidden!");
                                                    fetchReviews();
                                                } catch (error) {
                                                    toast.error("Failed to hide review");
                                                    console.error(error);
                                                }
                                            }}
                                        >
                                            Hide
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                setSelectedReviewId(review._id);
                                                setShowReviewConfirm(true);
                                            }}
                                        >
                                            Show
                                        </button>
                                    )}
                                    <button onClick={() => handleDelete(review._id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="manual-pagination">
                <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                    disabled={currentPage === 0}
                >
                    Previous
                </button>

                <span>
                    Page {currentPage + 1} of {totalPages}
                </span>

                <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                    disabled={currentPage === totalPages - 1}
                >
                    Next
                </button>
            </div>
            </div>


            {/* Confirmation Popup */}
            {
                showConfirm && (
                    <div className="confirm-popup">
                        <div className="confirm-content">
                            <p>Are you sure you want to delete this review?</p>
                            <div className="popup-actions">
                                <button onClick={() => confirmDelete(selectedVideoId)} className="confirm-btn">
                                    Confirm
                                </button>
                                <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }


            {showReviewConfirm && (
                <div className="confirm-popup">
                    <div className="confirm-content">
                        <p>Do you want to show this review on the site?</p>
                        <div className="popup-actions">
                            <button onClick={confirmShowReview} className="confirm-btn">Yes, Show It</button>
                            <button onClick={() => setShowReviewConfirm(false)} className="cancel-btn">Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </>
    );
};

export default HomePageReviews;
